import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ColorService {
  // color: the accent itself; strong: its 700 shade, for solid surfaces with white text.
  availableColors = [
    { name: "Red", value: "red", color: "#ef4444", strong: "#b91c1c" },
    { name: "Green", value: "green", color: "#34d399", strong: "#15803d" },
    { name: "Blue", value: "blue", color: "#2563eb", strong: "#1d4ed8" },
    { name: "Gray", value: "gray", color: "#6b7280", strong: "#4b5563" },
    { name: "Indigo", value: "indigo", color: "#4f46e5", strong: "#4338ca" },
    { name: "Purple", value: "purple", color: "#7c3aed", strong: "#6d28d9" },
  ];

  constructor() {}
}
